module.exports = __webpack_public_path__ + "img/last-installments.9122e42d.svg";